import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const FieldLabel = ({ label, children, disabled }) => (
  <Box
    sx={{
      mt: 1.5,
      // DropdownMenu (a shared, app-wide component) always applies its own
      // margin="normal" to its inner field — neutralize it here so every
      // field wrapped by FieldLabel gets consistent spacing regardless of
      // whether it's a plain TextField or a DropdownMenu underneath.
      '& .MuiFormControl-root': { margin: 0 }
    }}
  >
    <Typography
      component="label"
      sx={{
        display: 'block',
        mb: 0.75,
        color: disabled ? 'text.disabled' : '#68717c',
        fontSize: 12,
        fontWeight: 800,
        letterSpacing: '0.04em',
        textTransform: 'uppercase'
      }}
    >
      {label}
    </Typography>
    {children}
  </Box>
);

FieldLabel.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool
};

FieldLabel.defaultProps = {
  disabled: false
};

export default FieldLabel;
